<template>
	<SessionLabelPillContainer :color="label.color">
		<template v-if="sessionStore.canUserEditSession && interactive">
			<button class="label" @click="$emit('click')">
				{{ label.label }}
			</button>
			<button data-test="remove-button" class="px-2 ml-4 text-gray-400 hover:text-gray-100" @click="removeLabel">
				<BaseIcon name="mono/delete" class="mb-2 w-10 h-10" />
			</button>
		</template>
		<span v-else class="label">
			{{ label.label }}
		</span>
	</SessionLabelPillContainer>
</template>

<script>
import SessionLabelPillContainer from 'shared/components/SessionLabelPillContainer.vue'
import {useLabels} from 'shared/composables/useLabels'
import {useSessionStore} from 'shared/stores/session'

export default {
	name: 'SessionLabelPill',
	components: {SessionLabelPillContainer},
	props: {
		label: {type: Object, required: true},
		interactive: Boolean,
	},
	emits: ['click'],
	setup() {
		const {deleteSessionsLabels} = useLabels()
		return {deleteSessionsLabels, sessionStore: useSessionStore()}
	},
	methods: {
		async removeLabel() {
			if (!this.sessionStore.canUserEditSession) return
			return this.deleteSessionsLabels(this.label, this.$route.params.sessionId)
		},
	},
}
</script>

<style scoped>
.label {
	padding: 3px 10px;
	margin: -3px -10px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 16ch;
	text-align: left;
	color: var(--gray-300);
	user-select: none;
}
</style>
